import BasicRepository from "./basicRepository";
import Client from "../client";

class RetentionPolicyRepository extends BasicRepository<any, any> {
    constructor(client: Client) {
        super("RetentionPolicies", client);
    }
}

export default RetentionPolicyRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/retentionPolicyRepository.ts